export default __webpack_public_path__ + "static/media/iconBackground.6d5dd34e.svg";